import { scheduleShorthandOnEnterSaga } from './ScheduleShorthand.onenter.saga'; // polyfill webpack require.ensure

if (typeof require.ensure !== 'function') require.ensure = function (deps, cbFn) {
  return cbFn(require);
};
export default (function (store, client) {
  return {
    path: '/s(chedule)-v2/:scheduleId(\\d+)',
    status: 301,
    onEnter: function onEnter(nextState, replaceState, cb) {
      return store.runSagaOnce(scheduleShorthandOnEnterSaga, client, nextState, replaceState).done.then(cb, cb);
    }
  };
});